export enum RequestWarningType {
  TOO_MANY_RESULTS = 'TOO_MANY_RESULTS',
  CONCURRENT_UPDATE = 'CONCURRENT_UPDATE',
  /** The NSC Database does not know a GCID an account points at; handled, never rendered. */
  NOT_FOUND = 'NOT_FOUND',
}

/** The subset the search can produce, i.e. the ones `searchResults.warnings` translates. */
export type SearchRequestWarningType = Exclude<RequestWarningType, RequestWarningType.NOT_FOUND>;

/** A warning the search has a message for. NOT_FOUND is raised by the profile load, never by a
 * search client, but the shared RequestTracker cannot express that - so it is filtered out here
 * rather than given a message no user can ever see.
 */
export function isSearchRequestWarning(warning: RequestWarningType): warning is SearchRequestWarningType {
  return warning !== RequestWarningType.NOT_FOUND;
}

export class RequestWarning extends Error {
  constructor(
    public readonly type: RequestWarningType,
    message: string,
  ) {
    super(`RequestWarning(${type}): ${message}`);
    this.name = 'RequestWarning';
  }
}
